import { gql } from '@apollo/client';

export const SAVED_SESSIONS_QUERY = gql`
    query getSavedSessions {
        sessions {
            recordId
        }
    }
`;

export const SAVE_SESSION = gql`
    mutation SaveSession($recordId: Int!) {
        saveSession(recordId: $recordId) {
            session {
                recordId
            }
        }
    }
`;

export const REMOVE_SESSION = gql`
    mutation RemoveSession($recordId: Int!) {
        removeSession(recordId: $recordId) {
            session {
                recordId
            }
        }
    }
`;
